import _ from 'lodash'
import React, { useRef } from 'react'
import { Icon, Label, Menu } from 'semantic-ui-react'
import { uniqueKey } from '../../common/keys'
import { appIconTypes } from '../../enums/appIconTypes'
import TransitionWrapper from '../../wrappers/TransitionWrapper'
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares '

const MenuVert = ({
  activeMenuItem,
  activeMenuItems,
  asSquares,
  cn,
  extraProp,
  extraProps,
  header,
  labelColor,
  menuElements,
  menuItems,
  menuKey,
  oc,
  occ,
  selectedRelated,
  showCount,
  showKey,
  sortRelated,
  useIcons,
  useStartCase = true,
  useTransition,
}) => {

  if (asSquares) {

    const fnAltContent = (item) => {
      const { _count } = item
      return <Label size='mini' color={_count ? 'blue' : 'black'}>{_count || 0}</Label>
    }

    return <ItemMenuSquares
      menuItems={menuItems}
      imsType={_imsTypes.inline}
      onClick={oc}
      activeItem={activeMenuItem}
      caption={header}
      fn_altContent={showCount && fnAltContent}
      icon={'options'}
    />
  }

  const getActiveKey = () => {
    const { _itemKey } = activeMenuItem ?? {}
    return _itemKey ? _itemKey : activeMenuItem
  }

  const _activeKey = getActiveKey()
  const _activeKeys = activeMenuItems ? activeMenuItems : []

  const label_count = (itemOrKey) => {
    const { count, subCount } = occ(itemOrKey)
    if (subCount && subCount > 0) {
      return <div>
        <Label size='tiny' color={'black'} >{subCount}</Label>
        <Label size='tiny' color={count > 0 ? 'blue' : 'grey'} >{count}</Label>
      </div>
    } else {
      return <div><Label size='tiny' color={count > 0 ? 'blue' : 'grey'} >{count}</Label></div>
    }
  }

  const label_count_count = (count, countSelected) => <div>
    {countSelected && <Label size='tiny' color={countSelected > 0 ? 'green' : 'grey'} title={'Selected Count'} >{countSelected}</Label>}
    <Label size='tiny' color={count > 0 ? 'blue' : 'grey'} >{count}</Label>
  </div>

  const getItemProps = (dmi) => {

    let _name = dmi
    let _key = dmi
    let _extra;
    let _countt;
    let _counts;
    let _icon;

    if (_.isObject(dmi)) {

      const { _itemKey, name, lastName, displayName, firstName, startDate, startTime, _count, _countSelected, text, icon } = dmi

      _key = _itemKey ? _itemKey : name

      let caption = lastName && firstName
        ? `${lastName}, ${firstName}`
        : name;

      if (!caption && displayName) {
        caption = displayName
      }

      _name = caption ? caption : _.startCase(_key)

      if (!_name && text) { _name = _text }
      if (_count) { _countt = _count }
      if (_countSelected) { _counts = _countSelected }
      if (icon) { _icon = icon }

      _extra = startDate && startTime
        ? `${startDate}: ${startTime}`
        : startDate;
    }

    return { key: _key, name: _name, extra: _extra, count: _countt, countSelected: _counts, oc, itemIcon: _icon }
  }

  const isItemActive = (_key) => _activeKey === _key || (_activeKeys && _activeKeys.includes(_key))

  const extra_item = (dmi, ep, dpp) => {
    const cn = dpp ? 'extra-dp' : 'extra-key'
    if (dmi[ep]) {
      const value = dmi[ep]
      if (_.isArray(value)) {
        const divs = _.map(value, (v) => (
          <div className={cn}>{v}</div>
        ))
        divs.unshift(<div className={'extra-type'}>{ep}</div>)
        return divs
      } else {
        return <div className={cn}>{value}</div>
      }
    }
  }

  const extra_items = (dmi) => {
    const eis = _.map(extraProps, (extraProp) => (
      extra_item(dmi, extraProp, true)
    ))
    return eis
  }

  const menu_item = (dmi, index) => {

    const { name, key, extra, count, oc, countSelected, itemIcon } = getItemProps(dmi)
    const isActive = isItemActive(key)
    const isRelated = selectedRelated && selectedRelated.includes(key)
    const icon = appIconTypes[key]

    let cn = '';
    if (isRelated) { cn += ' rel' }
    if (isActive) { cn += ' sel' }

    return <Menu.Item
      key={uniqueKey('adv', 'mi', index, key)}
      className={!_.isEmpty(cn) ? cn : null}
      active={isActive}
      related={isRelated}
      onClick={() => { oc && oc(dmi) }}
    >
      <div>
        <div>{useIcons && <Icon size='small' name={icon ? icon : 'options'} color='blue' style={{ marginRight: '1em' }} />}{useStartCase ? _.startCase(name) : name}</div>
        {showKey && <div className='extra-key'>{key}</div>}
        {extra && <div className='extra'>{extra}</div>}
        {extraProp && extra_item(dmi, extraProp)}
        {extraProps && extra_items(dmi)}
      </div>
      {occ && label_count(key)}
      {showCount && count && label_count_count(count, countSelected)}
      {itemIcon && <div><Icon size='small' name={itemIcon} color='green' style={{ marginRight: '1em' }} /></div>}
    </Menu.Item>
  }

  const menu_vert = () => {

    const _mis = menuItems ? menuItems.map((dmi, index) => (menu_item(dmi, index))) : []
    const _miss = sortRelated ? _.orderBy(_mis, [item => item.props.related], ['desc']) : _mis;

    let _cn = 'menu-vert-col'
    if (cn) { _cn += ' ' + cn }

    return <Menu
      key={uniqueKey('mv', menuKey)}
      vertical
      secondary
      className={_cn}
    >
      {menuElements ? menuElements : _miss}
    </Menu>
  }

  const menu_vert_transition = () => <TransitionWrapper>
    {menu_vert()}
  </TransitionWrapper>

  const wrapper = () => <Wrapper
    header={header}
    content={useTransition ? menu_vert_transition() : menu_vert()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  return header ? wrapper() : menu_vert()
}

export default MenuVert